import type { WorkerMessageMap } from '~/composables/useServiceWorker'

export const createSectionsRouteMap = async ({ routes }: WorkerMessageMap['createSectionsRouteMap']): Promise<void> => {
  const map = new Map<number, number>()
  routes.forEach((route) => {
    ;(route.children || []).forEach((segment) => {
      ;(segment.children || []).forEach((section) => {
        map.set(section.id, route.id)
      })
    })
  })

  self.postMessage({
    type: 'sectionsRouteMapCreated',
    payload: map
  })
}
